	Object.defineProperty(exports, "__esModule", {
	    value: true
	});exports.default=window.GrimoireJS.lib.fundamental.Components.TransformComponent;


//////////////////
// WEBPACK FOOTER
// ./~/grimoirejs-fundamental/ref/Components/TransformComponent.js
// module id = 3
// module chunks = 0